<template>
  <v-form
    v-model="valid"
    ref="form"
    lazy-validation
    class="pa-4 px-4"
    @submit.prevent="createCategory"
  >
    <v-container>
      <div class="d-flex justify-end">
        <v-btn
          tile
          color="primary"
          @click="$router.push({ name: 'category-index' })"
        >
          <v-icon left>
            arrow_back
          </v-icon>
          Back
        </v-btn>
      </div>
      <v-row class="mb-2">
        <v-col offset-lg="4" cols="4" class="text-center">
          <v-text-field
            :counter="35"
            label="Name"
            v-model="category.name"
            :rules="nameRules"
          ></v-text-field>

          <v-textarea
            :counter="200"
            label="Description"
            :rules="descriptionRules"
            v-model="category.description"
            required
          ></v-textarea>
          <v-btn type="submit" class="mx-0 mt-4">Create</v-btn>
        </v-col>
      </v-row>
    </v-container>
  </v-form>
</template>
<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      valid: false,
      category: {
        name: "",
        description: ""
      },
      nameRules: [
        v => !!v || "Name is required",
        v => v.length >= 3 || "Name must be at least 3 characters",
        v => v.length <= 35 || "Name must be less than than 35 characters"
      ],
      descriptionRules: [
        v => !!v || "Description is required",
        v => v.length >= 3 || "Description must be at least 3 characters",
        v =>
          v.length <= 200 || "Description must be less than than 200 characters"
      ]
    };
  },
  methods: {
    async createCategory() {
      if (this.$refs.form.validate()) {
        this.$swal({
          title: "Adding Category...",
          html: "this will only take a moment...",
          icon: "info",
          didOpen: () => {
            this.$swal.showLoading();
          }
        });
        await this.$store.dispatch("categories/CREATE_CATEGORY", this.category);
        this.$swal.close();
        this.$swal({
          title: "Success",
          html: "Category has been added",
          icon: "info"
        });
      }
    }
  }
};
</script>
